import { React, PropTypes } from '../lib/imports';
import styled from '@emotion/styled';
import ToggleViewButton from '../components/chrome/ToggleViewButton';
const ToggleWrapper = styled.section`
  background: ${({ theme }) => theme.colors.headerBg};
  ${({ theme }) => `padding: ${theme.spacings.mega} ${theme.spacings.mega};`}
  display: flex;
  justify-content: center;
  width: 100%;
`;

const LeaderboardToggle = ({ options, handleViewToggle, currentView }) => {
  return (
    <ToggleWrapper>
      <ToggleViewButton options={options} handleViewToggle={handleViewToggle} currentView={currentView} />
    </ToggleWrapper>
  );
};

LeaderboardToggle.propTypes = {
  options: PropTypes.arrayOf(PropTypes.exact({ key: PropTypes.string, value: PropTypes.string })),
  handleViewToggle: PropTypes.func,
  currentView: PropTypes.string,
};

export default LeaderboardToggle;
